import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function useFormDataCRUD(
    submitFunction,
    updateFunction,
    removeFunction,
    key,
    _baseValues ={},
    onShowFunction,
    onEndFunction,
    defaultType= 'new',
    GetRowFunction,
){
    const { t } = useTranslation("forms");
    const [baseValues] = useState(_baseValues)
    const [submitting, setSubmitting] = useState(false)
    const [errorMessage] = useState('')
    const [object, setObject] = useState(_baseValues)
    const [formType, setFormType] = useState(defaultType)

    const onChange = (e, {name, value})=>{
        setObject({...object, [name]:value})
    };

    async function submit(value){
        const data = {...baseValues, ...value}
        setSubmitting(true)
        try{
            const submitted = await submitFunction(data)
            console.log(data);
            setSubmitting(false)
            toast.success(t("add-success"))
            onEnd();
            return submitted
        } catch (e){
            if( e.response?.data?.Message!=null){
                toast.error( e.response?.data?.Message);
            }else{
            toast.error(t("add-failed"));
            console.log(e);
            }
        }
        setSubmitting(false)

    }

    async function update(value){
        setSubmitting(true)
        try{
            const updated = await updateFunction(value)
            setSubmitting(false)
            toast.success(t("update-success"))
            onEnd()
            return updated
        } catch (e){
            if( e.response?.data?.Message!=null){
                toast.error( e.response?.data?.Message);
            }else
            toast.error(t("update-failed"))
            console.log(e);
        }
        setSubmitting(false)
    }


    async function remove(id){
        setSubmitting(true)
        try{
            const removed = await removeFunction(id)
            // console.log(removed.data);
            console.log("the remove"+  removed.data);

            if(removed.data){
                if (removed?.data==="no"){
                    toast.error(t("cannot-delete-linked"))
                }else{
                    toast.success(t("delete-success"))
                    onEnd()
                }
            } else {
                toast.error(t("cannot-delete-linked"))
            }
            setSubmitting(false)
            return removed
        } catch (e){
            console.log(e);
            toast.error(e)
        }
        setSubmitting(false)
        
    }
    
    async function getRow(value){
        setSubmitting(true)
        try{

            const ressponse = await GetRowFunction(value)
            setSubmitting(false)
            return ressponse
        } catch (e){
            toast.error(t("fetch-error"))
            console.log(e);
        }
        setSubmitting(false)
        return null;
    }
    

    function onShow(newObject ={}, type = 'new'){
        // if(get(newObject, 'constructor.name')=== 'Class') newObject ={}
        setObject(newObject)
        setFormType(type)
        onShowFunction && onShowFunction()
        
    }

    function onEnd(){
        setObject(_baseValues)
        setFormType('new');
        onEndFunction && onEndFunction()

    }

    return {
        onChange,
        submit,
        update, 
        remove,
        submitting,
        errorMessage,
        onShow,
        onEnd,
        object,
        formType,
        getRow
    }
}